<template>
    <div v-if="!apiCallback"
        class="mobile:p-[15px] tablet:p-[20px] print:max-w-full relative shadow-custom print:shadow-none print:mt-0 max-w-full tablet:max-w-[768px] laptop:max-w-[960px] desktop:max-w-[1140px] largeDesktop:max-w-[1320px] mx-auto font-roboto rounded-[20px] bg-white"
        :class="(is_from_mobile == 0 && !$helper.isProxyLoggedIn()) ? '-mt-[35px]' : 'mt-[20px]'">
        <!-- header buttons -->
        <div v-if="is_from_mobile == 0"
            class="flex items-center justify-end gap-1.5 pb-[10px] border-b border-[#ccc] print:hidden">
            <button @click="printPdf()" type="button"
                class="group transition-all duration-300 h-[36px] w-[36px] justify-center text-[14px] font-normal rounded-full flex items-center gap-2.5 border-[1px] border-[#FE5000] text-[#FE5000] hover:text-[#fff] bg-[#fff] hover:bg-[#FE5000]">
                <img src="../../assets/images/print-icon.png" alt="icon"
                    class="w-[20px] h-[20px] object-contain group-hover:hidden block">
                <img src="../../assets/images/print-icon-hover.png" alt="icon"
                    class="w-[20px] h-[20px] object-contain hidden group-hover:block">
            </button>
            <!-- <button type="button"
                class="group transition-all duration-300 px-[15px] py-[7px] text-[14px] font-normal rounded-[4px] flex items-center gap-2.5 border-[1px] border-[#003087] text-[#003087] hover:text-[#fff] bg-[#fff] hover:bg-[#003087]">
                <img src="../../assets/images/email-icon.png" alt="icon"
                    class="w-[20px] h-[20px] object-contain group-hover:hidden block">
                <img src="../../assets/images/email-icon-hover.png" alt="icon"
                    class="w-[20px] h-[20px] object-contain hidden group-hover:block">
                Send
                Email</button> -->
        </div>
        <!-- only for mobile  -->
        <div class="text-center py-[15px] border-b tablet:border-0 border-[#ccc] mobile:block tablet:hidden">
            <h4 class="text-[20px] tablet:text-[36px] print:text-[28px] font-semibold m-0 text-[#003087]">INVOICE #
                {{
                    invoicePdf?.data?.info?.invoice_id }}</h4>
            <h2 class="text-[18px] tablet:text-[22px] font-semibold m-0 text-[#333]">BOOKING # {{
                invoicePdf?.data?.info?.job_id }}</h2>
            <p class="text-[14px] font-normal m-0 text-[#333]">Date of Invoice: {{
                $helper.formatDate(invoicePdf?.data?.info?.created_at) }}</p>
            <p v-if="invoicePdf?.data?.info?.is_paid != 0" class="text-[14px] font-normal m-0 text-[#333]">Invoice
                Paid: {{
                    $helper.formatDate(invoicePdf?.data?.info?.paid_date) }}</p>
        </div>

        <div v-if="invoicePdf?.data?.header"
            class="mt-0 tablet:mt-4 tablet:text-right tablet:flex flex-col items-end py-[15px] tablet:py-[10px] border-b border-[#ccc]">
            <h4 class="text-[20px] tablet:text-[36px] print:text-[28px] font-semibold m-0 text-[#003087]">{{
                invoicePdf?.data?.header?.company_name }}</h4>
            <span class="text-[14px] font-medium text-[#003087]">Company License #
                {{ invoicePdf?.data?.header?.company_license }}</span>
            <p class="text-[14px] font-normal m-0 text-[#333]">{{ invoicePdf?.data?.header?.company_address }}</p>
            <a :href="`tel:${invoicePdf?.data?.header?.customer_service_phone?.replace(/\D/g, '')}`"
                class="text-[14px] font-normal m-0 block transition-all duration-300 no-underline w-fit text-[#333] hover:text-[#FE5000]">{{
                    $helper.formatPhoneNumber(invoicePdf?.data?.header?.customer_service_phone) }}</a>
            <a :href="`mailto:${invoicePdf?.data?.header?.customer_service_email}`"
                class="text-[14px] font-normal m-0 block transition-all duration-300 no-underline w-fit text-[#333] hover:text-[#FE5000]">{{
                    invoicePdf?.data?.header?.customer_service_email }}</a>
        </div>
        <div v-if="invoicePdf?.data?.info"
            class="tablet:grid grid-cols-5 gap-2 mt-0 tablet:mt-4 py-[15px] tablet:py-[10px]">

            <div class="col-span-3 ">
                <h4 class="text-[14px] tablet:text-[16px] font-normal mb-1 text-[#003087]">INVOICE TO:</h4>
                <h2 class="text-[20px] tablet:text-[24px] print:text-[20px] font-semibold m-0 text-[#333]">{{
                    invoicePdf?.data?.info?.consumer_name }}</h2>
                <p class="text-[14px] font-normal m-0 text-[#333]"><span class="font-semibold text-black-100">Service
                        Address: </span> {{
                            invoicePdf?.data?.info?.address }}</p>
                <a :href="`mailto:${invoicePdf?.data?.info?.email}`"
                    class="text-[14px] font-normal m-0 block w-fit transition-all duration-300 no-underline text-[#0d6efd] hover:text-[#FE5000]">{{
                        invoicePdf?.data?.info?.email }}</a>
            </div>
            <!-- only for tablet/desktop  -->
            <div class="col-span-2 tablet:text-right mobile:mt-2 tablet:mt-[0px] mobile:hidden tablet:block">
                <h4 class="text-[20px] tablet:text-[36px] print:text-[28px] font-semibold m-0 text-[#003087]">INVOICE #
                    {{
                        invoicePdf?.data?.info?.invoice_id }}</h4>
                <h2 class="text-[18px] tablet:text-[22px] font-semibold m-0 text-[#333]">BOOKING # {{
                    invoicePdf?.data?.info?.job_id }}</h2>
                <p class="text-[14px] font-normal m-0 text-[#333]">Date of Invoice: {{
                    $helper.formatDate(invoicePdf?.data?.info?.created_at) }}</p>
                <p v-if="invoicePdf?.data?.info?.is_paid != 0" class="text-[14px] font-normal m-0 text-[#333]">Invoice
                    Paid: {{
                        $helper.formatDate(invoicePdf?.data?.info?.paid_date) }}</p>
            </div>
        </div>
        <table v-if="invoicePdf?.data?.line_items"
            class="table text-[13px] tablet:text-[14px] mt-4 mobile:hidden tablet:table">
            <thead>
                <tr>
                    <th
                        class="rounded-ss-[5px] text-[13px] print:text-white print:!bg-[#003087] tablet:text-[14px] !font-normal">
                        #</th>
                    <th class="text-[13px] tablet:text-[14px] print:text-white print:!bg-[#003087] !font-normal">
                        Quantity</th>
                    <th class="text-[13px] tablet:text-[14px] print:text-white print:!bg-[#003087] !font-normal">
                        DESCRIPTION
                    </th>
                    <th
                        class="rounded-tr-[5px] text-[13px] tablet:text-[14px] print:text-white print:!bg-[#003087] !font-normal text-right">
                        TOTAL
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(value, index) in invoicePdf?.data?.line_items" :key="index">
                    <td class="text-[13px] tablet:text-[14px] !bg-[#efefef]">{{ index + 1 }}</td>
                    <td class="text-[13px] tablet:text-[14px] !bg-[#efefef]">{{ value.quantity }}</td>
                    <td class="text-[13px] tablet:text-[14px] !bg-[#efefef]">{{ value.item_name }}</td>
                    <td class="text-[13px] tablet:text-[14px] !bg-[#efefef] text-right">Included</td>
                </tr>
                <tr>
                    <td colspan="3" class="text-[13px] tablet:text-[14px] text-right bg-white">Sales Tax</td>
                    <td class="text-[13px] tablet:text-[14px] text-right !border-solid !border-b !border-[#ddd]">{{
                        invoicePdf?.data?.line_items?.tax_amount != null
                            ? `$${$helper.formatAmount(invoicePdf.data.line_items.tax_amount)}`
                            : '0.00'
                    }}</td>
                </tr>
                <tr v-if="invoicePdf?.deppClaimDiscount !== null">
                    <td colspan="3" class="text-[13px] tablet:text-[14px] text-right bg-white">Claim Discount</td>
                    <td class="text-[13px] tablet:text-[14px] text-right !border-solid !border-b !border-[#ddd]">${{
                        $helper.formatAmount(invoicePdf?.deppClaimDiscount) }}</td>
                </tr>
                <tr v-if="invoicePdf?.data?.discount_amount">
                    <td colspan="3" class="text-[13px] tablet:text-[14px] text-right bg-white">Claim Discount</td>
                    <td class="text-[13px] tablet:text-[14px] text-right !border-solid !border-b !border-[#ddd]">
                        {{
                            invoicePdf?.data?.discount_amount != null
                                ? `$${$helper.formatAmount(invoicePdf.data.discount_amount)}`
                                : '0.00'
                        }}</td>
                </tr>
                <tr>
                    <td colspan="3" class="text-[13px] tablet:text-[14px] text-right bg-white">Total</td>
                    <td class="text-[13px] tablet:text-[14px] text-right !border-solid !border-b !border-[#ddd]">${{
                        $helper.formatAmount(invoicePdf?.data?.total) }}</td>
                </tr>
                <tr v-if="invoicePdf?.data?.info?.is_paid != 0">
                    <td colspan="3" class="text-[13px] tablet:text-[14px] text-right bg-white">Payment Type</td>
                    <td class="text-[13px] tablet:text-[14px] text-right !border-solid !border-b !border-[#ccc]">{{
                        invoicePdf?.data?.payment_type
                        }}</td>
                </tr>
            </tbody>
        </table>
        <table v-if="invoicePdf?.data?.line_items"
            class="table text-[13px] tablet:text-[14px] mt-2 !mb-0 mobile:table tablet:hidden print:hidden">
            <thead>
                <tr>
                    <th class="rounded-s-[5px] text-[13px] tablet:text-[14px] !font-normal">Description
                    </th>
                    <th class="rounded-e-[5px] text-[13px] tablet:text-[14px] !font-normal text-right">
                        TOTAL
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(value, index) in invoicePdf?.data?.line_items" :key="index">
                    <td class="text-[13px] tablet:text-[14px] bg-white">{{ value.item_name }} x {{ value.quantity }}
                    </td>
                    <td class="text-[13px] tablet:text-[14px] bg-white text-right">Included</td>
                </tr>
            </tbody>
        </table>
        <ul
            class="list-none mobile:flex tablet:hidden flex-col !mt-2 !px-[5px] mx-0 rounded-[8px] !border !border-[#ccc] print:hidden">
            <li class="flex items-center justify-between text-[13px] text-[#333] p-[10px] !border-b !border-[#ccc]">
                Sales Tax
                <span class="text-black-100">{{
                    invoicePdf?.data?.line_items?.tax_amount != null
                        ? `$${$helper.formatAmount(invoicePdf.data.line_items.tax_amount)}`
                        : '0.00'
                }}</span>
            </li>
            <li v-if="invoicePdf?.deppClaimDiscount !== null"
                class="flex items-center justify-between text-[13px] text-[#333] p-[10px] !border-b !border-[#ccc]">
                Claim Discount
                <span class="text-black-100">${{
                    $helper.formatAmount(invoicePdf?.deppClaimDiscount) }}</span>
            </li>
            <li v-if="invoicePdf?.data?.discount_amount"
                class="flex items-center justify-between text-[13px] text-[#333] p-[10px] !border-b !border-[#ccc]">
                Claim Discount
                <span class="text-black-100">{{
                    invoicePdf?.data?.discount_amount != null
                        ? `$${$helper.formatAmount(invoicePdf.data.discount_amount)}`
                        : '0.00'
                }}</span>
            </li>
            <li class="flex items-center justify-between text-[13px] text-[#333] p-[10px] !border-b !border-[#ccc]">
                Total
                <span class="text-black-100">${{
                    $helper.formatAmount(invoicePdf?.data?.total) }}</span>
            </li>
            <li v-if="invoicePdf?.data?.info?.is_paid != 0"
                class="flex items-center justify-between text-[13px] text-[#333] p-[10px]">
                Payment Type
                <span class="text-black-100">{{
                    invoicePdf?.data?.payment_type
                    }}</span>
            </li>
        </ul>
        <div v-if="invoicePdf?.data?.device_info && invoicePdf?.data?.info?.is_paid != 0"
            class="py-4 tablet:flex items-center justify-between !border-b !border-[#000]">
            <div>
                <p class="text-[14px] font-normal m-0 text-[#333]"><span class="font-semibold text-black-100">Approved
                        by
                        the Customer: </span>{{
                            invoicePdf?.data?.info?.last_name }}, {{
                        invoicePdf?.data?.info?.first_name }}</p>
                <p class="text-[14px] font-normal m-0 text-[#333]"><span class="font-semibold text-black-100">IP:
                    </span>{{
                        invoicePdf?.data?.device_info?.client_ip }}</p>
                <p class="text-[14px] font-normal m-0 text-[#333]"><span class="font-semibold text-black-100">Date Time:
                    </span>{{
                        invoicePdf?.data?.device_info?.created_date_time }}</p>
                <p class="text-[14px] font-normal m-0 text-[#333]"><span class="font-semibold text-black-100">Device
                        Type:
                    </span>{{
                        invoicePdf?.data?.device_info?.device_type }}</p>
            </div>
            <div v-if="invoicePdf?.signature" class="flex items-end gap-[20px]">
                <p class="m-0 font-lato text-[16px] text-[#000] font-bold">Signature:</p>
                <div class="border-b border-[#ccc]">
                    <img :src="invoicePdf?.signature" alt="Signature" class="w-[200px] h-[150px] object-contain">
                </div>
            </div>
        </div>
        <div class="pt-[15px] text-center">
            <p class="text-[14px] font-normal m-0 text-[#333]">
                Invoice was created on a computer and is valid without the signature and seal.
            </p>
        </div>

        <button @click="backClicked()"
            class=" mt-[30px] block w-max mx-auto font-lato text-[16px] px-[40px] py-[5px] rounded-full text-[#092E87] border-[1px] border-[#092E87] hover:bg-[#092E87] hover:text-[#fff]">Back</button>
    </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
    data() {
        return {
            is_from_mobile: (this.$route.query.is_from_mobile ?? 0) == 1
        };
    },

    computed: {
        ...mapGetters(["invoicePdf", "apiCallback"]),
    },

    mounted() {

        this.getInvoicePdf({
            invoice_id: this.$route.params.id
        })
    },

    watch: {
    },

    methods: {
        ...mapActions(["getInvoicePdf"]),

        printPdf() {
            window.print()
        },


        backClicked() {
            this.$router.go(-1);
        },
    }
}
</script>
<style scoped>
@media print {

    table,
    thead,
    tbody,
    tr,
    th,
    td {
        -webkit-print-color-adjust: exact !important;
        print-color-adjust: exact !important;
    }

    th {
        background-color: #003087 !important;
        color: #ffffff !important;
    }

    td.bg-gray {
        background-color: #efefef !important;
    }
}
</style>
